// @flow
import React from "react"

const PlusIcon = () => (
  <svg width="29" height="29" xmlns="http://www.w3.org/2000/svg">
    <g fill="#FFF" fillRule="nonzero">
      <rect x="10" width="7" height="28" rx="3.5" />
      <path d="M0 13.5C0 11.567 1.513 10 3.38 10h21.24c1.867 0 3.38 1.567 3.38 3.5S26.487 17 24.62 17H3.38C1.512 17 0 15.433 0 13.5z" />
    </g>
  </svg>
)

export default PlusIcon



// WEBPACK FOOTER //
// ./src/assets/icons/PlusIcon.js